(function() {
    'use strict';
    
a3_cabin_reports.controller('CustomerModalCtrl', CustomerModalCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name CustomerCtrl
    * @description 
    *  Report a bug of the application
    * @ngInject
    */
function CustomerModalCtrl($scope, $uibModalInstance, $timeout, InfoAPIService, customerIncident) {
        $scope.successful = false;
        $scope.error = false;


        var q =  InfoAPIService.sendCustomerIncident(customerIncident.flightDescription,customerIncident.question, customerIncident.description, customerIncident.image);

        q.then(function(responseData){
			if(responseData.data.data){
                $scope.successful = true;
			}
			else {
             $scope.error = true;
			}
            $timeout(function() {
					$uibModalInstance.close();
                }, 3000);
		},
		function(){
             $scope.error = true;
                $timeout(function() {
					$uibModalInstance.close();
                }, 3000);
		});
}
    
    
})();
    